<template>
  <div :class="msgType === 'warning' ? 'message-content' : 'message-content1'">
    <img
      class="img"
      v-if="msgType === 'warning'"
      src="../../../../assets/appraise/msg_1.png"
    />
    <img class="img" v-else src="../../../../assets/appraise/msg_2.png" />
    <div class="title" v-if="msgType === 'warning'">约谈</div>
    <div class="title1" v-else>问责</div>
    <div :class=" msgType === 'warning' ? 'msg' : 'msg1' ">{{ content }}</div>
  </div>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: () => {
        return "#FF8C19";
      },
    },
    content: {
      type: String,
      default: () => {
        return "昆明市 季度综合考评已连续3次处于末位";
      },
    },
    msgType: {
      type: String,
      default: () => {
        return "warning";
      },
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.message-content1 {
  width: 100%;
  display: flex;
  height: 36px;
  background: rgba(255,77,77,0.1);
  border-radius: 1px;
  align-items: center;
  margin-bottom: 12px;
}
.message-content {
  width: 100%;
  display: flex;
  height: 36px;
  background: rgba(255, 140, 25, 0.1);
  border-radius: 1px;
  align-items: center;
  margin-bottom: 12px;
}
.img {
  width: 12px;
  height: 12px;
  margin-left: 12px;
}
.title {
  width: 24px;
  height: 12px;
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 140, 25, 1);
  line-height: 12px;
  margin-left: 4px;
}
.title1 {
  width: 24px;
  height: 12px;
  font-size: 12px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 77, 77, 1);
  line-height: 12px;
   margin-left: 4px;
}
.msg {
  width: 243px;
  height: 12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 140, 25, 1);
  line-height: 12px;
  margin-left: 12px;
}
.msg1 {
  width: 243px;
  height: 12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 77, 77, 1);
  line-height: 12px;
   margin-left: 12px;
}
</style>
